module.exports = __webpack_public_path__ + "static/media/chatbotprice.c8d08816.png";